module.exports = __webpack_public_path__ + "static/img/brees-2007-top-image.cda519c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-top-image.jpg
// module id = mvq+
// module chunks = 1